import { observer } from 'mobx-react';
import * as Pusher from 'pusher-js';
import * as React from 'react';
import CalendarStore from '../../../CalendarStore';

interface Props {
  channel: Pusher.Channel;
  store: CalendarStore;
}

class CalendarBinding extends React.Component<Props, {}> {
  componentDidMount() {
    const { channel, store } = this.props;

    channel.bind('refresh-calendar-events', () => {
      switch (store.state.kind) {
        case 'ready':
          store.refresh();
          break;
        case 'waiting':
        case 'loading':
        case 'navigating':
        case 'error':
        case 'refresh':
          break;
      }
    });
  }

  componentWillUnmount() {
    const { channel } = this.props;
    channel.unbind_all();
  }

  render() {
    return null;
  }
}

export default observer(CalendarBinding);
